function getCountryFromUrl() {
    var _a, _b;
    if (typeof window === 'undefined') {
        return '';
    }
    const pathname = (_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '';
    const parts = pathname.split('/').filter(Boolean);
    if (!parts.length) {
        return '';
    }
    const firstSegment = parts[0].toLowerCase();
    const isLocaleLike = /^[a-z]{2}-[a-z]{2}$/.test(firstSegment);
    if (!isLocaleLike) {
        return '';
    }
    return firstSegment;
}

export { getCountryFromUrl };
